import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import clsx from 'clsx';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';



const QontoConnector = withStyles((theme) => ({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 10px)',
        right: 'calc(50% + 10px)',
    },
    active: {
        '& $line': {
            border: 'none',
            borderTop: '2px solid ' + theme.palette.secondary.main
        },
    },
    completed: {
        '& $line': {
            border: 'none',
            borderTop: '2px solid ' + theme.palette.secondary.main
        },
    },
    line: {
        border: 'none',
        borderTop: '2px solid ' + theme.palette.grey[300]
    },
}))(StepConnector);

const useQontoStepIconStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.grey[300],
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: theme.palette.secondary.main
    }
})
);

function QontoStepIcon(props: StepIconProps) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;
    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {completed ? <CheckCircleIcon color='secondary' /> : active ? <RadioButtonCheckedOutlinedIcon color='secondary' /> : <RadioButtonUncheckedIcon />}
        </div>
    );
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    }),
);


interface DeloitteStepperProps {
    steps: DeloitteStep[],
    currentStep: number
}
export interface DeloitteStep {
    label: string;
    step: number;
    component?: any;
}

export const DeloitteStepper: FC<DeloitteStepperProps> = (props) => {
    const classes = useStyles();
    const { steps, currentStep } = props;
    return (
        <div className={classes.root}>
            <Stepper alternativeLabel activeStep={currentStep} connector={<QontoConnector />} style={{ padding: 24 }}>
                {steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel StepIconComponent={QontoStepIcon}>{step.label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
}
